<template>
  <label
    :for="item.label.replace(' ', '-')"
    :class="[
      'FilterItem',
      {
        'FilterItem--disabled': disabled,
        'FilterItem--checked': checked,
        'FilterItem--has-colour': swatchStyles
      },
    ]"
  >
    <input
      :id="item.label.replace(' ', '-')"
      :disabled="disabled"
      type="checkbox"
      class="FilterItem__hidden-input"
    />
    <div class="FilterItem__checkmark">
      <span
        v-if="swatchStyles && swatchStyles.src"
        :style="{ backgroundImage: `url(${swatchStyles.src})` }"
        class="FilterItem__colour-swatch FilterItem__colour-swatch-image"
      />
      <span
        v-else
        :style="swatchStyles"
        class="FilterItem__colour-swatch"
      />
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <span class="FilterItem__text" v-html="item.label"/>
  </label>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  removeTag: {
    type: Boolean,
    default: false,
  },
});

const swatchStyles = computed(() => {
  if (
    props.item.additionalFilterData?.swatch?.styles
  ) {
    return props.item.additionalFilterData.swatch.styles;
  }
  if (
    props.item.additionalFilterData?.swatch?.image
  ) {
    return props.item.additionalFilterData.swatch.image;
  }

  return '';
});

const checked = computed(() => {
  return props.item.isRefined
})
</script>

<style lang="postcss">
.FilterItem {
  @apply relative text-xs flex items-center cursor-pointer p-1 pr-3 bg-grey-lighter rounded-full
  transition-all duration-200
  hover:bg-grey-light hover:shadow-inner;

  &--disabled {
    @apply opacity-50 cursor-not-allowed;
  }
}

.FilterItem--checked {
  @apply bg-grey-dark text-white hover:bg-off-black;

  .FilterItem__checkmark {
    @apply bg-white;

    &::after {
      @apply scale-[0.8] opacity-100;
    }
  }

  .FilterItem__colour-swatch {
    @apply scale-[0.8];
  }
}

.FilterItem__hidden-input {
  @apply absolute opacity-0 pointer-events-none;
}

.FilterItem__checkmark {
  @apply mr-2 relative  shrink-0 rounded-full p-0
  border-solid border-[1px] border-grey-dark
  w-8 h-8;
  
  @screen md {
    @apply h-5 w-5
  }

  &:after {
    @apply absolute top-0 left-0
    w-full h-full rounded-full opacity-0 bg-gradient
    scale-[0.6] transition-all duration-200;
    content: "";
  }
}
.FilterItem__colour-swatch {
  @apply block absolute
  inset-0 rounded-full
  transition-transform duration-200 scale-100;

  &-image {
    background-size: cover;
  }
}

.FilterItem__text {
  @apply whitespace-nowrap;
}

/* Colour Swatch Overrides */
.FilterItem--has-colour {
  .FilterItem__checkmark {
    @apply border-grey;
    
    &::after {
      @apply hidden;
    }
  }

  &.FilterItem--checked {
    .FilterItem__checkmark {
      @apply border-white;
    }
  }
}
</style>
